import { REDUX_STORE_DEFAULTS } from "../config"

const initialState = {
  allBookingData: [],
}

const multipleBookingReducer = (state = initialState, action) => {
  switch (action.type) {
    case REDUX_STORE_DEFAULTS.UPDATE_VEHICLE_DATA():
      return {
        ...state,
        allBookingData: updateDataArray(
          state.allBookingData,
          action.payload.newVehicle,
          "vehicle",
          action.payload.multipleBookingStatus
        ),
      }
    case REDUX_STORE_DEFAULTS.UPDATE_SERVICE_DATA():
      return {
        ...state,
        allBookingData: updateDataArray(
          state.allBookingData,
          action.payload.newService,
          "service",
          action.payload.multipleBookingStatus
        ),
      }
    case REDUX_STORE_DEFAULTS.UPDATE_ADDON_SERVICE_DATA():
      return {
        ...state,
        allBookingData: updateDataArray(
          state.allBookingData,
          action.payload.newAddOnService,
          "addOnService",
          action.payload.multipleBookingStatus
        ),
      }
    case REDUX_STORE_DEFAULTS.UPDATE_DATA():
      return {
        ...state,
        allBookingData: updateDataArray(
          state.allBookingData,
          action.payload.data,
          action.payload.stepNo,
          action.payload.multipleBookingStatus
        ),
      }
    case REDUX_STORE_DEFAULTS.UPDATE_SUBTOTAL():
      return {
        ...state,
        allBookingData: updateServicePricesInDataArray(
          state.allBookingData,
          action.payload.otherVehicleInfo
        ),
      }
    default:
      return state
  }
}

const updateDataArray = (dataArray, newData, stepNo, multipleBookingStatus) => {
  const latestIndex = dataArray.length - 1
  const latestData = dataArray[latestIndex]

  if (stepNo === 2) {
    if (
      dataArray.length === 0 ||
      (hasServiceAndAddOnService(latestData) && multipleBookingStatus)
    ) {
      // Add a new vehicle entry if the array is empty or the latest entry has both service and addOnService
      return [...dataArray, { vehicle: newData }]
    } else {
      // Update the latest vehicle entry
      return dataArray.map((data, i) => {
        if (i === latestIndex) {
          return {
            ...data,
            vehicle: newData,
            service: {},
            addOnService: [],
            subTotal: 0,
            totalAddOnPrice: 0,
          }
        }
        return data
      })
    }
  }

  if (stepNo === 3 && latestIndex >= 0 && dataArray[latestIndex].vehicle) {
    // Add or update the service data in the latest vehicle entry
    return dataArray.map((data, i) => {
      if (i === latestIndex) {
        return {
          ...data,
          service: newData,
          addOnService: [],
          subTotal: newData.salePrice,
          totalAddOnPrice: 0,
        }
      }
      return data
    })
  }

  if (stepNo === 4 && latestIndex >= 0 && dataArray[latestIndex].vehicle) {
    // Update the add-on service data in the latest vehicle entry
    return dataArray.map((data, i) => {
      // let bookingAddOnPrice = calculateAddOnPrice(data)
      // console.log("redux price", bookingAddOnPrice)
      if (i === latestIndex) {
        // Check if addOnService already exists, if yes, merge with existing data
        const updatedAddOnService = data.addOnService ? newData : newData
        let bookingAddOnPrice = calculateAddOnPrice(updatedAddOnService)
        // console.log("redux price", bookingAddOnPrice)
        return {
          ...data,
          addOnService: updatedAddOnService,
          totalAddOnPrice: bookingAddOnPrice,
          subTotal: bookingAddOnPrice + data.service.salePrice,
        }
      }
      return data
    })
  }

  if (stepNo === 1) {
    return []
  }

  return dataArray
}

const hasServiceAndAddOnService = (data) => {
  return data.service && data.addOnService
}

const calculateAddOnPrice = (addOnServices) => {
  if (!Array.isArray(addOnServices)) return 0
  return addOnServices.reduce((total, service) => total + service.addOnPrice, 0)
}
// const calculateAddOnPrice = (addOnServices, vid, otherVehicleInfo, stepNo) => {
//   if (!Array.isArray(addOnServices)) return 0
//   return addOnServices.reduce((total, service) => {
//     let addOnPrice = service.addOnPrice
//     // Apply custom logic based on vid and otherVehicleInfo
//     if (vid === 5 && otherVehicleInfo.rvLength > 1 && stepNo === 6) {
//       addOnPrice = otherVehicleInfo.rvLength * addOnPrice
//     } else if (vid === 7 && otherVehicleInfo.busSeats > 1 && stepNo === 6) {
//       addOnPrice = otherVehicleInfo.busSeats * addOnPrice
//     } else if (vid === 8 && otherVehicleInfo.boatLength > 1 && stepNo === 6) {
//       addOnPrice = otherVehicleInfo.boatLength * addOnPrice
//     } else if (vid === 10 && otherVehicleInfo.houseSqFeet > 1 && stepNo === 6) {
//       addOnPrice = otherVehicleInfo.houseSqFeet * addOnPrice
//     }
//     return total + addOnPrice
//   }, 0)
// }
// Helper function to map vid to property key
const vehicleTypeKey = (vid) => {
  const mapping = {
    5: "rvLength",
    7: "busSeats",
    8: "boatLength",
    10: "houseSqFeet"
  };
  return mapping[vid] || null;
};

const getRatesFromOtherVehicleInfo = (otherVehicleInfo, type) => {
  if (!Array.isArray(otherVehicleInfo)) return []; // Ensure it's an array
  return otherVehicleInfo
    .filter(item => item.type === type)
    .map(item => ({
      rate: item.rate,
      picture: item.picture ?? []
    }));
};

const handleServicePrice = (salePrice, rates, rateIndex, stepNo) => {
  if (stepNo !== 6) return salePrice;

  let multiplier = rates[rateIndex]?.rate ?? 1; // Use correct rate per index

  return multiplier > 1 ? multiplier * salePrice : salePrice;
};

const getTotalLength = (rates, rateIndex) => {
  return rates[rateIndex]?.rate ?? 0; // Get correct length per entry
};

const getImagesForVehicle = (rates, rateIndex) => {
  return rates[rateIndex]?.picture ?? []; // Fetch correct image per entry
};

const updateServicePricesInDataArray = (dataArray, otherVehicleInfo) => {
  let rateCounters = {}; // Track used rates per vehicle type

  return dataArray.map((data) => {
    if (data.vehicle && data.service) {
      let type = null;

      if (data.vehicle.staffDisplayName === "RVs Motorhomes") type = "rvLength";
      else if (data.vehicle.staffDisplayName === "Passender bus") type = "busSeats";
      else if (data.vehicle.staffDisplayName === "Boats") type = "boatLength";
      else if (data.vehicle.staffDisplayName === "House") type = "houseSqFeet";

      let rates = type ? getRatesFromOtherVehicleInfo(otherVehicleInfo, type) : [];

      if (!rateCounters[type]) rateCounters[type] = 0; // Initialize counter

      const rateIndex = rateCounters[type] % rates.length; // Cycle through available rates

      const updatedServicePrice = handleServicePrice(
        data.service.salePrice,
        rates,
        rateIndex,
        6
      );

      const totalLength = getTotalLength(rates, rateIndex);
      const pricingType = totalLength > 0 ? "rate" : "fixed";

      const images = getImagesForVehicle(rates, rateIndex); // Get correct images

      rateCounters[type]++; // Move to next rate in sequence

      return {
        ...data,
        subTotal:
          updatedServicePrice +
          calculateAddOnPrice(
            data.addOnService,
            data.vehicle.id,
            otherVehicleInfo,
            6
          ),
        images: images??[], // Correctly assigned images per vehicle type
        totalLength: totalLength,
        pricingType: pricingType,
      };
    }
    return data;
  });
};



export default multipleBookingReducer
